/**
 * 协议正文（用户协议 / 隐私政策 / 支付通道授权说明）。
 *
 * 面向用户的正式版本，与 App 端同源（RN/Web 共用）。结构参照主流 C2C 闲置交易平台
 * （如闲鱼）并覆盖工信部规范强制分节：平台定位与居间性质、账号与实名、发布规范与禁售
 * 清单、行为规范、分账抽佣、交易规则、匿名机制、服务定位与免责、知识产权、隐私、违约、
 * 变更、仲裁与争议解决、通知送达、不可抗力、完整协议等。
 *
 * 简版隐私摘要（二级弹窗内展示）见 PRIVACY_SUMMARY_POINTS。
 */

export const PRIVACY_SUMMARY_POINTS: string[] = [
  '我们仅在为你提供服务所必需的范围内收集信息：设备标识、网络状态、你主动填写的资料与浏览/交易记录。',
  '信息用途：账号与交易撮合、安全风控与反诈、服务质量改进、依法配合监管。',
  '第三方 SDK:短信、即时通讯、内容安全、支付等合作方仅在对应功能触发时按最小必要原则获取信息。',
  '实名认证仅采集姓名、身份证号、银行预留手机号与卡号做四要素文本核验，不采集身份证照片或人脸图像。',
  '你的权利：可随时查询、更正、删除个人信息，注销账号，并一键关闭个性化推荐。',
  '树洞等匿名场景下你对其他用户匿名，但平台后台保留可识别映射用于司法配合与滥用防控。',
  '点击“同意”表示你已阅读并接受《用户协议》与《隐私政策》；不同意将无法使用本 App。',
];

export const AGREEMENT_TEXT = `《我行用户协议》

【特别提示】请你在使用我行 App（以下简称“本平台”或“我们”）提供的各项服务前，认真阅读并充分理解本协议全部条款，特别是以加粗或下划线形式提示的免除或限制责任、争议解决与法律适用等条款。你勾选同意或开始使用本平台服务，即视为你已阅读、理解并同意接受本协议的全部约定。如你不同意本协议任何内容，请立即停止使用本平台服务。

第一条 定义与适用范围
1.1 本平台是一个连接闲置物品与个人技能服务供需双方的撮合平台。你可以在平台出售个人闲置物品、提供个人技能服务（以下发布方统称“卖家”），或购买闲置物品、技能服务（以下购买方统称“买家”）。平台提供信息展示、即时通讯、订单交易、支付结算、评价与争议处理等功能。
1.2 本平台系信息与技术服务提供者，仅提供居间撮合，不直接向用户出售物品或提供被撮合的具体技能服务，不是买卖任何一方交易的当事人，亦不对物品或服务的质量、真伪、合法性作担保；但平台依法承担平台经营者应尽的信息审核、日常管理与协助处理义务。
1.3 本协议适用于你对本平台所有客户端、网站及相关服务的访问与使用。本平台可能就特定服务（如收款账户、争议处理）另行制定单独协议或规则，该等单独协议或规则与本协议具有同等效力。

第二条 账号注册与实名
2.1 你承诺以真实、准确、完整的信息注册账号，并在信息变更时及时更新。你应妥善保管账号及登录凭证，对账号项下的一切行为负责。
2.2 根据国家法律法规及监管要求，涉及交易、收款、提现等环节时，你须完成实名认证。实名仅采集你的姓名、身份证号、银行预留手机号与银行卡号进行四要素文本核验，相关信息以行业标准加密方式存储，仅用于身份核验、风控反诈与依法配合监管；平台不采集你的身份证照片或人脸图像。
2.3 一个自然人原则上仅可注册并使用一个买家身份与一个卖家身份。平台有权对疑似多账号、虚假注册、刷单炒信、养号、批量注册等行为采取限制、冻结或注销措施。
2.4 你应自行采取合理措施保障账号安全，不向他人出借或转让账号，不在不可信设备上登录。账号项下发生的操作均视为你本人或经你授权的行为，由此产生的责任由你承担，但平台存在过错的除外。
2.5 你发现账号被盗用或存在异常的，应立即通过官方渠道通知平台；平台核实后将采取合理措施协助你保护账号安全，但对你通知前已发生的损失，平台在已尽合理义务范围内不承担责任。

第三条 发布规范与禁止发布清单（重要条款）
3.1 卖家发布闲置物品或技能服务时，应如实、准确、完整地描述：物品应载明成色、瑕疵、真伪与来源；服务应载明内容、范围、价格、交付方式与周期。不得虚假宣传、夸大承诺或以任何方式误导买家。
3.2 你不得在平台发布、出售或提供下列任何物品或服务：
（1） 法律法规禁止交易的物品：枪支弹药、管制器具、毒品及相关制品、易燃易爆有毒有害等危险品、国家重点保护的野生动植物及其制品、文物等；
（2） 假冒伪劣商品，或侵犯他人商标权、著作权、专利权等知识产权的商品；
（3） 依法需要特定资质、许可或备案方可经营的：药品、医疗器械、处方、烟草、彩票、金融放贷、虚拟货币及其兑换等；
（4） 色情、赌博、涉政涉恐、暴力、封建迷信等违法或不良的信息、物品与服务；
（5） 个人隐私信息、他人账号、外挂作弊程序、木马病毒及其他非法软硬件；
（6） 涉及人身安全或健康、而提供方不具备相应资质的服务（如医疗诊疗、心理治疗、危机干预等）；
（7） 违反公序良俗或平台规则明令禁止的其他物品与服务。
3.3 平台有权对涉嫌违规的发布内容进行审核、下架或删除，并视情节对账号采取限制、冻结或注销措施；涉嫌违法犯罪的，平台有权依法向有权机关报告。

第四条 用户行为规范
4.1 你不得发布、传播任何违反国家法律法规、公序良俗的信息，包括但不限于色情、暴力、赌博、诈骗、侵犯他人知识产权或隐私、虚假宣传等内容。
4.2 你不得利用本平台从事任何形式的洗钱、套现、传销、非法集资、规避监管或损害他人合法权益的行为。
4.3 你不得通过技术手段干扰、破坏平台正常运行，不得抓取、爬取平台数据，不得对平台进行逆向工程。
4.4 卖家不得诱导买家脱离平台进行私下交易、私下转账或线下结算。一经发现，平台有权取消订单、冻结相关资金、限制或注销账号，并不承担因此产生的任何损失；由此造成平台或第三方损失的，违规方应予赔偿。
4.5 买卖双方应自行依法履行纳税义务。平台依照法律法规及监管要求，可能需就交易信息向有权机关报送或协助代扣代缴，你应予以配合并提供真实、准确的信息。
4.6 你不得发布、传播任何涉及自杀、自残、危害他人人身安全的违法或不良信息；如平台监测到危险信号，平台在现阶段仅进行被动记录与合规留存，不构成专业干预，亦不因此承担超出法律规定的额外义务。

第五条 平台分账规则与抽佣（重要条款）
5.1 买卖双方通过本平台达成交易后，订单资金通过微信支付、支付宝等持牌支付机构的官方分账体系进行结算。
5.2 平台就撮合服务收取服务费（佣金）。除另有书面约定或活动规则外，平台抽取成交金额的百分之五（5%），卖家实际收取成交金额的百分之九十五（95%）。该比例可能因不同品类、活动或政策调整而变化，平台将以协议更新或公告方式提前告知。
5.3 你理解并同意，平台作为分账主体之一参与官方分账架构，分账结果以支付机构的清结算记录为准。退款、取消、争议处理等场景下的资金流向，依照本平台交易规则与相应单独规则执行。
5.4 因你自身原因（如提供虚假信息、违规交易）导致的税费、罚款或第三方索赔，由你自行承担。

第六条 交易规则
6.1 买家下单并通过持牌支付机构支付订单金额后，交易进入履约环节；订单资金在交易完成前依平台交易规则进行保障性管理，不由平台形成资金沉淀池。
6.2 涉及实物闲置物品的，卖家应按约定的时间、方式交付，如实告知瑕疵；买家应及时验收确认。涉及技能服务的，卖家应按约定的内容、范围与周期交付，买家应及时确认。
6.3 交易完成并经确认或到达平台规则约定的自动确认时点后，平台按第五条分账规则进行结算。到账采用 T+N 自动结算，无需卖家手动提现。
6.4 退款、取消与争议按平台《交易规则》及相应单独规则处理；资金流向以支付机构清结算记录为准。

第七条 树洞与匿名机制说明（重要条款）
7.1 本平台部分场景（如“树洞”等情感支持/陪伴类互动）向其他用户呈现为匿名。你理解并知悉：该匿名仅指你对平台其他用户不展示真实身份，并不意味着平台无法识别你的身份。
7.2 为履行法律义务、配合司法及监管机关、防控滥用与违法犯罪，平台后台保留你账号与匿名内容之间的可识别映射关系，并对该等数据的访问实施严格的权限控制与操作审计。
7.3 你不得借匿名机制从事任何违法或侵害他人合法权益的行为，否则平台有权依法依规向有权机关提供相关信息。

第八条 平台服务定位与免责（重要条款）
8.1 本平台为信息撮合与技术服务平台，并非医疗、心理诊疗或危机干预机构。平台提供的任何陪伴、倾诉、情感支持类内容或服务，均不构成医疗建议或专业心理治疗。
8.2 如你或他人存在健康或生命安全方面的危机或紧急情况，请立即联系专业医疗机构或拨打当地紧急求助电话。平台现阶段对危险信号采取被动监控与记录，不承诺主动干预或限时响应。
8.3 在法律允许的最大范围内，平台不对因不可抗力、第三方原因、用户自身原因或非平台过错导致的损失承担责任。

第九条 知识产权
9.1 本平台的软件、界面、商标、文字、图形、音视频、数据库及其衍生作品等知识产权，归平台或相关权利人所有，受著作权法、商标法、专利法及其他法律法规与国际公约保护。未经书面许可，你不得以任何方式使用、复制、修改、传播、出售或进行商业利用。
9.2 你在平台发布、上传或以其他方式提供的文字、图片、音视频及其他内容（以下统称“用户内容”），你承诺对其拥有完整、合法的权利或已获得充分授权，且不侵犯任何第三方的知识产权、肖像权、名誉权、隐私权或其他合法权益。
9.3 为提供、维护、推广和改进平台服务之目的，并在法律允许的范围内，你授予平台一项免费的、非独占的、可转授权的许可，许可平台对用户内容进行存储、使用、复制、展示、传播及必要的技术处理（如格式转换、安全审核）。该许可在你删除相应用户内容或注销账号后，于平台正常运营与合规留存所必需的合理期限内继续有效。
9.4 若第三方主张你提供的用户内容侵犯其合法权益，平台有权依据“通知—删除”等规则采取必要措施，并保留向你追偿因此遭受损失的权利。

第十条 隐私与个人信息保护
10.1 平台依据《我行隐私政策》收集、使用、存储、共享你的个人信息，请你一并阅读《隐私政策》。
10.2 平台采取访问控制、加密存储、操作审计、最小授权、安全监测等技术与管理措施保护你的个人信息。但你理解并知悉，互联网及信息技术环境并非绝对安全，平台已尽合理努力的，不对因黑客攻击、计算机病毒、电信故障、不可抗力等非平台过错原因导致的信息泄露或损失承担超出法律规定的责任。
10.3 发生个人信息安全事件时，平台将依照法律法规启动应急响应，及时评估影响，采取补救措施，并按规定向你告知与向监管机关报告。

第十一条 违约处理
11.1 你违反本协议或平台相关规则的，平台有权根据行为性质与情节轻重，单独或合并采取下列措施：警示提醒、限期改正、删除或屏蔽相关内容、限制或暂停部分功能、冻结账号、终止全部服务，并保留依法追究法律责任的权利。
11.2 因你的违约或违法行为给平台、其他用户或任何第三方造成损失的，你应承担全部赔偿责任，赔偿范围包括但不限于直接损失、维权合理支出（含律师费、公证费、诉讼费）及平台为处置违规所支出的合理成本。
11.3 平台依据本协议采取的处置措施，不影响平台依法向有权机关报告、移送或提起诉讼的权利。平台对账号采取冻结、注销等措施的，账号项下的虚拟权益、未结资金等按平台相应规则与法律规定处理。
11.4 平台依据其单方判断对涉嫌违规行为采取处置措施，已尽到合理注意义务的，不就该等措施本身向你承担赔偿责任，但你有权依照平台申诉规则提出申诉。

第十二条 协议变更、中止与终止
12.1 平台有权根据法律法规及运营需要修订本协议，修订后将以协议版本号变更并通过 App 内提示等方式告知。你继续使用即视为接受修订；不接受的应停止使用。
12.2 你可随时停止使用并注销账号；账号注销后，平台将依照法律法规与隐私政策处理你的个人信息。

第十三条 仲裁、争议解决与法律适用（重要条款）
13.1 本协议的订立、效力、解释及争议解决，均适用中华人民共和国大陆地区法律。
13.2 因本协议或本平台服务产生的争议，双方应首先友好协商解决。
13.3 仲裁条款：协商不成的，双方可约定将争议提交平台运营者所在地有管辖权的仲裁委员会，按照其届时有效的仲裁规则进行仲裁；仲裁裁决为终局裁决，对双方均具有约束力。仲裁费用除仲裁机构另有决定外，由败诉方承担。
13.4 未达成前述仲裁合意的，任一方均可就争议向平台运营者所在地有管辖权的人民法院提起诉讼。
13.5 本协议部分条款被认定无效或不可执行的，不影响其他条款的效力。

第十四条 通知与送达
14.1 平台可通过 App 内站内信、系统通知、弹窗、你预留的手机号或其他你认可的方式向你送达通知；该等通知于发送之日视为送达。涉及协议或规则变更的，平台将通过协议版本号变更并以显著方式提示。
14.2 你应保证预留联系方式真实、有效并及时更新；因联系方式不实或未及时更新导致通知未能送达的，相关法律后果由你自行承担。
14.3 你向平台发出的通知，应通过平台指定的官方渠道提交，于平台实际收到时生效。

第十五条 不可抗力与免责
15.1 因台风、地震、洪水、疫情等自然灾害，或战争、政府行为、监管政策调整、电信主干线路故障、黑客攻击、基础电信运营商或第三方支付/云服务故障等平台不能合理控制的事件，导致平台无法履行或延迟履行本协议的，平台不承担违约责任，但应在合理范围内采取措施减轻影响并及时告知。
15.2 平台对服务的及时性、安全性、无错误不作超出法律规定的明示或默示担保；在法律允许的最大范围内，平台对间接损失、利润损失、数据损失等不承担赔偿责任。
15.3 因你违反本协议、违反法律法规或第三方原因导致的任何索赔、损失或责任，由你自行承担，并使平台免责。

第十六条 完整协议与可分性
16.1 本协议连同平台不时发布并生效的各项单独协议、规则、公告，构成你与平台之间就本平台服务达成的完整协议。
16.2 本协议任一条款被有权机关认定为无效、违法或不可执行的，不影响其余条款的效力，双方应以最接近原条款本意且合法有效的方式予以替代。

第十七条 其他
17.1 本协议的标题仅为方便阅读，不影响条款含义的解释。
17.2 平台未行使或迟延行使本协议项下任何权利，不构成对该权利的放弃；单项或部分行使权利不排斥其再次或进一步行使。
17.3 未经平台书面同意，你不得转让本协议项下的权利义务；平台可在业务调整、合并、分立等情形下将本协议项下权利义务一并转移，并以适当方式告知。

附则：协议版本号与生效
本协议版本号以 App 内“协议版本”展示为准，自发布之日起生效。平台将在合法、合规的前提下，持续优化撮合机制、资金保障与争议处理流程，保护买卖双方的合法权益，营造诚信、安全、文明的交易与互动环境。我们建议你在每次协议版本更新时重新完整阅读全文，以充分理解你在使用本平台过程中的权利与义务。如你对本协议有任何疑问，可通过《隐私政策》载明的联系方式与我们联系。感谢你对我行平台的信任与支持。`;

export const PRIVACY_POLICY_TEXT = `《我行隐私政策》

生效日期：2026年7月26日
更新日期：2026年7月26日

【特别提示】北京天衡晋远科技有限公司（以下简称“我们”或“平台”）深知个人信息对你的重要性，并会尽力保护你的个人信息安全可靠。请你在使用我行 App 及相关服务前，务必仔细阅读并充分理解本政策，特别是以粗体标识的条款。你同意本政策，即表示你已了解我们提供的功能，以及功能运行所需的必要个人信息，并给予相应的收集、使用授权。

一、适用范围
本政策适用于我行以网站、App、小程序等各种形态提供的产品与服务。本政策不适用于第三方通过我行平台向你提供的服务，以及第三方独立收集你个人信息的行为（该等行为受第三方自身隐私政策约束）。

二、我们如何收集和使用你的个人信息
我们仅出于本政策所述目的、在为你提供功能所必需的最小范围内收集和使用你的个人信息。
（一）帮助你成为用户及账户管理
注册与登录：手机号（用于接收短信验证码）、系统自动生成的账号昵称；你可自愿补充头像、个人简介。
实名认证：当你进行交易、收款、提现时，依法需完成实名认证。我们仅收集你的姓名、身份证号、银行预留手机号与银行卡号，进行四要素文本核验。我们不采集你的身份证照片，也不进行人脸／面部识别。相关信息加密存储，仅用于身份核验、风控反诈与依法配合监管。
（二）帮助你浏览、搜索与个性化推荐
你的浏览、搜索、收藏记录，用于内容展示与个性化推荐。你可在设置中一键关闭个性化推荐（定向推荐）。
（三）帮助你完成交易
你发布闲置物品或技能服务时填写的标题、描述、图片、价格等信息；下单、支付与分账记录；涉及实物交付时你填写的收货或联系信息。
（四）即时通讯与互动
买卖双方在平台内沟通的即时通讯内容，用于撮合、履约与争议处理；订单与系统消息通知。
（五）客服与争议处理
为核验身份、处理投诉与交易争议，我们可能使用你的账号、订单与沟通记录。
（六）安全保障
为保障账号与交易安全、进行反诈风控，我们收集设备型号、操作系统、设备标识符、IP 地址、网络状态及必要的服务日志信息。
（七）系统权限与本地存储
在你使用相应功能时，我们会向你申请必要的系统权限（如通知、相册）；你可拒绝或随时在系统设置中关闭。我们在客户端使用本地存储（如 Cookie／localStorage）保存登录态与偏好设置。
（八）征得授权同意的例外
依据法律法规，在与国家安全和公共安全、犯罪侦查、你或他人重大合法权益、你自行公开、履行法定义务等相关的情形下，我们收集、使用个人信息无需另行征得你的同意。

三、我们如何共享、转移、公开你的个人信息及第三方 SDK
（一）共享
我们不会向第三方共享你的个人信息，但下列情形除外：事先取得你的明确同意；为实现功能所必需（如支付、消息推送）；依据法律法规或监管、司法机关的强制性要求。
（二）第三方 SDK 清单
我们仅在最小必要范围内集成下列第三方 SDK，均在对应功能触发时调用、以加密方式传输：
1. 阿里云短信服务——注册／登录验证码下发；收集手机号、设备 IP；会话级留存。
2. 银行卡四要素核验服务——实名认证；收集姓名、身份证号、银行预留手机号、银行卡号（均为文本）；通过后字段加密存储，不采集、不留存身份证照片或人脸图像。
3. 阿里云内容安全——对商品／即时通讯／评价／头像等文本与图像做合规审核；审核结果留存。
4. 消息推送 SDK——订单／即时通讯／系统通知下发；收集设备 token、厂商 token、应用前后台状态。
5. 微信支付 SDK／支付宝 SDK——担保交易支付与官方分账；收集支付订单号、支付结果回调。
6. 崩溃与性能监控 SDK——稳定性诊断；收集堆栈、设备型号、系统版本、网络类型（手机号／身份证／银行卡明文经客户端拦截，不上报）。
我们不集成需要读取通讯录、地理位置（GPS）、麦克风的 SDK。
（三）转移
除因合并、分立、收购等原因导致个人信息转移（届时我们将要求继受方继续受本政策约束）外，我们不会转移你的个人信息。
（四）公开披露
除依法或经你另行同意外，我们不会公开披露你的个人信息。

四、你的权利
你有权查阅、复制、更正、补充、删除你的个人信息，改变或撤回授权同意，注销账号，以及一键关闭个性化推荐。你也有权要求我们对完全依靠自动决策且对你产生显著影响的结果作出说明。你可通过 App 内相应入口或第八条载明的联系方式行使上述权利，我们将在法定期限内（一般不超过 15 个工作日）予以答复。

五、我们如何存储和保护你的个人信息
（一）存储地点与期限：你的个人信息存储于中华人民共和国境内。我们仅在实现处理目的所必需的期限及法律法规要求的期限内保存你的个人信息；交易相关信息依法律法规要求保存（如自交易完成之日起不少于三年）；账号注销后设置不少于 30 天的等待期，期满后依法删除或匿名化处理。
（二）安全措施：我们采取符合行业标准的安全措施（SSL／HTTPS 传输加密、敏感字段加密存储、访问控制、最小授权、操作审计、安全监测）保护你的个人信息。但你理解并知悉互联网环境并非绝对安全；发生个人信息安全事件时，我们将依法启动应急响应，及时评估影响、采取补救措施，并按规定向你告知与向监管机关报告。

六、政策的更新
本政策可能因法律法规或业务调整而更新。发生重大变更时，我们将通过协议版本号变更、App 内显著提示等方式告知你；你继续使用即视为接受更新后的政策。

七、未成年人个人信息保护
本平台主要面向成年人。若你为不满十四周岁的儿童，请在监护人指导下阅读，并在监护人同意本政策后使用。我们不会主动收集儿童个人信息，发现后将尽快删除。

八、联系我们
运营主体：北京天衡晋远科技有限公司。如你对本政策或个人信息保护有任何疑问、投诉或建议，可通过 App 内“设置-反馈”或客服邮箱 support@tianhengjinyuan.com 与我们联系；涉及个人信息保护事宜，你亦可联系我们的个人信息保护负责人。我们将及时核实并处理。

附录：相关定义
个人信息：以电子或其他方式记录的、能够单独或与其他信息结合识别特定自然人身份或反映特定自然人活动情况的各种信息。
敏感个人信息：一旦泄露或非法使用，容易导致自然人的人格尊严受到侵害或人身、财产安全受到危害的个人信息，包括身份证件号码、银行账户等。
儿童：不满十四周岁的未成年人。
去标识化／匿名化：通过技术处理，使个人信息在不借助额外信息的情况下无法识别特定自然人（去标识化），或无法识别特定自然人且不能复原（匿名化）的过程。`;

export const PAYMENT_CHANNEL_AUTH_TEXT = `《支付通道授权说明》

一、官方分账架构说明
本平台交易资金通过微信支付、支付宝等持牌支付机构提供的官方分账（分账/合单）能力进行结算。买家支付的订单金额，由支付机构按平台设置的分账规则，分别结算至卖家与平台。资金流转全程在持牌支付机构体系内完成，平台不形成资金沉淀池。

二、平台分账主体资质声明
平台作为官方分账架构中的分账接收方之一，依法持有或正在办理开展该业务所必需的相关资质（含营业执照、支付机构商户与分账资质、ICP 备案、App 备案、经营许可等）。在相关资质完备并接入真实支付通道前，平台以合规方式进行灰度验证，不进行真实资金清结算。

三、你的授权
当你进行支付、收款或提现绑定操作时，即表示你授权平台与相应支付机构按本说明及支付机构规则处理你的交易与必要信息，用于完成支付、分账、退款与对账。

四、退款与争议
退款、取消、争议场景下的资金流向依照平台交易规则与支付机构清结算记录执行。

五、版本与生效
本说明版本号以 App 内“协议版本”为准，自发布之日起生效。如有疑问请通过《隐私政策》载明的联系方式与我们联系。`;
